import HeaderCard from '../General/HeaderCard';
import Button from '@mui/material/Button';
import { useEffect, useState } from 'react';
import { getUser } from '../../helpers/token';
import LoginButton from '../Header/LoginButton';

export default function NewUserCard({ isRounded }) {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (getUser() === undefined) setShow(true);
  }, []);

  const handleOpen = () => {
    setOpen(true);
  };

  if (!show) return <></>;

  return (
    <>
      <div className="pt-3">
        <HeaderCard
          noborder
          title="Travel, Write, Earn"
          titlesize="h6"
          bgCard
          newUserCard
          isRounded={isRounded}
          content={
            <div className="px-3">
              Join TravelFeed and start earning from your own travel blog!
              <div className="text-center py-3">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpen}
                >
                  Join now
                </Button>
              </div>
            </div>
          }
        />
      </div>
      {open && (
        <LoginButton
          open={open}
          hideButtons
          onClickClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
